import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {I18nModule, provideDefaultConfig} from '@spartacus/core';
import {DcpConfiguratorUpdateMessageComponent} from './dcp-configurator-update-message.component';
import {LoadingIndicatorComponent} from '../shared/loading-indicator/loading-indicator.component';

@NgModule({
  imports: [CommonModule, I18nModule, LoadingIndicatorComponent],
  providers: [
    provideDefaultConfig({
      cmsComponents: {
        ConfiguratorUpdateMessage: {
          component: DcpConfiguratorUpdateMessageComponent,
        },
      },
    }),
  ],
  declarations: [DcpConfiguratorUpdateMessageComponent],
  exports: [DcpConfiguratorUpdateMessageComponent],
})
export class DcpConfiguratorUpdateMessageModule {}
